import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import DropdownBlock from '~/components/new/blocks/DropdownBlock.vue'
import LampOn from '~/components/icons/LampOn.vue'
import MedalStar from '~/components/icons/MedalStar.vue'
import Teacher from '~/components/icons/Teacher.vue'
import Edit from '~/components/icons/Edit.vue'
import type { UserFormTypes } from '~/types/Catalog'
// import { elementsToString } from '~/util/other'

type ArtistInfoDropdowns = {
  authorInfo: {
    educations?: any
    qualifications?: any
    concept?: string,
    styles?: string[],
    themes?: string[],
    exhibitions?: any
    publications?: any
  },
  showEmpty?: boolean,
  customize?: boolean
}

type ArtistInfoDropdownsEmits = {
  (e: 'edit', value: UserFormTypes): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InfoDropdowns',
  props: {
    authorInfo: { default: () => ({
    educations: [],
    qualifications: [],
    styles: [],
    themes: [],
    exhibitions: [],
    publications: [],
    concept: 'Не указано'
  }) },
    showEmpty: { type: Boolean, default: false },
    customize: { type: Boolean, default: false }
  },
  emits: ["edit"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'edit', value: UserFormTypes): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { authorInfo: {
    educations?: any
    qualifications?: any
    concept?: string,
    styles?: string[],
    themes?: string[],
    exhibitions?: any
    publications?: any
  }, showEmpty: boolean, customize: boolean };



const empty = ref('Не указано')



// const info = computed(() => ({
//   educations: elementsToString(props.authorInfo.educations),
//   qualifications: elementsToString(props.authorInfo.qualifications),
//   exhibitions: elementsToString(props.authorInfo.exhibitions),
//   publications: elementsToString(props.authorInfo.publications, ['link'])
// }))

const isValidArr = (arr?: any[]) => {
  return arr && arr.length > 0
}

const elements = [
  { title: 'Образование и квалификация', iconComponent: Teacher },
  { title: 'Выставки и публикации', iconComponent: LampOn },
  { title: 'Творческая идея', iconComponent: MedalStar }
] as const

const items = computed(() => {
  const result: typeof elements = []

  if (props.showEmpty) { return elements }

  if (isValidArr(props.authorInfo.educations) || isValidArr(props.authorInfo.qualifications)) {
    result.push(elements[0])
  }

  if (isValidArr(props.authorInfo.exhibitions) || isValidArr(props.authorInfo.publications)) {
    result.push(elements[1])
  }

  if (isValidArr(props.authorInfo.styles) || isValidArr(props.authorInfo.themes) || props.authorInfo.concept !== 'Не указано') {
    result.push(elements[2])
  }

  return result
})

const getEditEmitValue = (title: typeof elements[number]['title']): UserFormTypes => {
  switch (title) {
    case 'Выставки и публикации':
      return 'public & exhibit'

    case 'Образование и квалификация':
      return 'educ & qualif'

    case 'Творческая идея':
      return 'concept'
  }
}


return { __sfc: true,emit, empty, props, isValidArr, elements, items, getEditEmitValue, DropdownBlock, Edit }
}

})